<template>
  <div class="app-textarea">
    <v-textarea
      :id="id"
      :rows="rows"
      :value="value"
      :label="label"
      :class="{ 'gray--text text--lighten-1': disabled }"
      :placeholder="placeholder"
      :counter="counter"
      :error-messages="$formErrors(v)"
      :disabled="disabled"
      :required="isRequired"
      :maxLength="maxLength"
      :hide-details="hideDetails"
      @input="input"
      @blur="blur"
      color="secondary"
      auto-grow
    >
      <span
        slot="label"
        v-bind:id="id"
        :class="{ 'required-field': isRequired }"
      >
        {{ label }}
      </span>
    </v-textarea>
  </div>
</template>

<script>
export default {
  name: 'AppTextArea',
  props: {
    value: {
      type: String,
      default: undefined
    },
    label: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    counter: {
      type: [Number, String],
      default: undefined
    },
    id: {
      type: String,
      default: undefined
    },
    rows: {
      type: Number,
      default: () => 1
    },
    v: {
      type: Object,
      default: () => {}
    },
    maxLength: {
      type: [String, Number],
      default: () => ''
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    hideDetails: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isRequired() {
      // eslint-disable-next-line no-prototype-builtins
      return this.v?.$params?.required
    }
  },
  methods: {
    input(value) {
      this.$emit('input', value)
    },
    blur(value) {
      this.$emit('blur', value)
    }
  }
}
</script>
